import { TFunction } from 'i18next';
import { Side } from '../../Models/Side';

export function replaceSideWithText(
    t: TFunction,
    activeSide: Side,
    withColorMarking?: boolean
): {
    SIDE: string;
    SIDEUPPER: string;
    LorR: string;
    OTHERSIDE: string;
    OTHERSIDEUPPER: string;
} {
    if (withColorMarking)
        return {
            SIDE: t(
                `pairing:Pairing_Feature:${
                    activeSide === 'left' ? 'Left' : 'Right'
                }Title`
            ).toLowerCase(),
            SIDEUPPER: t(
                `pairing:Pairing_Feature:${
                    activeSide === 'left' ? 'Left' : 'Right'
                }Title`
            ).toUpperCase(),
            OTHERSIDE: '',
            OTHERSIDEUPPER: '',
            LorR: '',
        };
    return {
        SIDE: t(
            `common:Common_Feature:${activeSide === 'left' ? 'Left' : 'Right'}s`
        ).toLowerCase(),
        SIDEUPPER: t(
            `common:Common_Feature:${activeSide === 'left' ? 'Left' : 'Right'}s`
        ).toUpperCase(),
        OTHERSIDE: t(
            `common:Common_Feature:${activeSide === 'left' ? 'Right' : 'Left'}s`
        ).toLowerCase(),
        OTHERSIDEUPPER: t(
            `common:Common_Feature:${activeSide === 'left' ? 'Right' : 'Left'}s`
        ).toUpperCase(),
        LorR: activeSide === 'left' ? 'L' : 'R',
    };
}
